// src/components/MeterBrands.jsx
import React, { useEffect, useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import {
  fetchMeterBrands,
  createMeterBrand,
  deleteMeterBrand,
} from "../../data/fetchData";

const MeterBrands = () => {
  const [loading, setLoading] = useState(true);
  const [brands, setBrands] = useState([]);
  const [newBrand, setNewBrand] = useState("");

  useEffect(() => {
    fetchMeterBrands()
      .then((list) => setBrands(list))
      .catch((err) => console.error("Error fetching meter brands:", err))
      .finally(() => setLoading(false));
  }, []);

  const handleAddBrand = () => {
    createMeterBrand(newBrand)
      .then((b) => {
        setBrands((prev) => [...prev, b]);
        setNewBrand("");
      })
      .catch((err) => console.error("Error creating meter brand:", err));
  };

  const handleDeleteBrand = (id) => {
    deleteMeterBrand(id)
      .then(() => {
        setBrands((prev) => prev.filter((b) => b.id !== id));
      })
      .catch((err) => console.error("Error deleting meter brand:", err));
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div className="p-4">
      <div className="flex mb-4">
        <input
          type="text"
          value={newBrand}
          onChange={(e) => setNewBrand(e.target.value)}
          placeholder="Lisa uus arvesti mark"
          className="flex-grow p-2 border border-gray-300 rounded-md mr-2"
        />
        <button
          onClick={handleAddBrand}
          className="p-2 bg-primary text-white rounded-md hover:bg-primary-hover"
        >
          <FaPlus />
        </button>
      </div>
      <ul className="space-y-2">
        {brands.map((b) => (
          <li
            key={b.id}
            className="flex justify-between items-center p-2 border border-gray-300 rounded-md"
          >
            <span className="truncate w-3/4">{b.name}</span>
            <button
              onClick={() => handleDeleteBrand(b.id)}
              className="text-red-500 hover:text-red-700"
            >
              <FaTrashAlt />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MeterBrands;
